export const USE_TEMPLATE_PIPELINE = false;
